import AccountSendersCollectionList from '../Collections/AccountSendersCollectionList';

export { AccountSendersData as default };

/**
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class AccountSendersData
{
  /**
   * Collection list of whitelisted senders
   *
   * @public
   *
   * @type {AccountSendersCollectionList}
   *
   * @since 7.0.0
   */
  whitelist = new AccountSendersCollectionList("sender");

  /**
   * Collection List of blacklisted senders
   *
   * @public
   *
   * @type {AccountSendersCollectionList}
   *
   * @since 7.0.0
   */
  blacklist = new AccountSendersCollectionList("sender");
}